import { documentationActions } from '../../actions/constant';

const { GET_EOC_CREATE_DOCUMENT_DATA, RESET_EOC_CREATE_DOCUMENT_DATA } = documentationActions;

const initialState: object = {
  document: null,
  activeTab: null,
  patientData: null,
  episodeOfCareId: null,
  requiredDocument: false,
};

export const eocCreateDocumentDataReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_EOC_CREATE_DOCUMENT_DATA: {
      return {
        document: action.payload.document,
        activeTab: action.payload.activeTab,
        patientData: action.payload.patientData,
        episodeOfCareId: action.payload.episodeOfCareId,
        requiredDocument: action.payload.requiredDocument ? true : false,
      };
    }

    case RESET_EOC_CREATE_DOCUMENT_DATA:
      return initialState;

    default:
      return state;
  }
};
